export enum ClipboardContentType {
  TEXT_HTML = 'text/html',
  TEXT_PLAIN = 'text/plain',
}

export enum ClipboardActionTypes {
  COPY_CONTENT = '@CLIPBOARD/COPY_CONTENT',
}
